module.exports = __webpack_public_path__ + "static/media/latte.fbeabb79.svg";